import React from 'react';
import {connect} from 'react-redux';
import Logo from '../Presentation/Logo';
import MainMenu from '../Presentation/Navigation/MainMenu';
import {openPushMenu} from '../../actions/PushMenu';

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.openPushMenu = this.openPushMenu.bind(this);
    }

    openPushMenu() {
        this.props.dispatch(openPushMenu());
    }

    render() {
        return <header className="header">
            <div className="container">
                <div className="row">
                    <div className="col-md-1 col-sm-3 col-xs-6">
                        <Logo />
                    </div>
                    <div className="col-md-11 col-sm-9 col-xs-6 text-right">
                        <div className="menu-holder">
                            <nav className="main-menu">
                                <MainMenu authenticated={this.props.authenticated} name={this.props.name}/>
                            </nav>
                            <button className="hamburger hamburger--elastic" type="button" onClick={this.openPushMenu} >
                                <span className="hamburger-box">
                                    <span className="hamburger-inner" />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    }
}

const mapStateToProps = (state) => {
    return {
        authenticated: state.auth.authenticated,
        name: state.user.userData.fullname
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Containers/Header.js